import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/rv/success.svg'
import _imports_1 from '@/assets/images/rv/warning.svg'
import _imports_2 from '@/assets/images/rv/error.svg'


const _hoisted_1 = { class: "confirmIcon" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "noticeIcon"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "noticeIcon"
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: "",
  class: "noticeIcon"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "提示", -1)
const _hoisted_6 = {
  key: 0,
  class: "confirmCon hasBtnConfirm"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, " Do you confirm sumbit below records to SIPO? ", -1)
const _hoisted_8 = { style: {"margin-bottom":"20px"} }
const _hoisted_9 = {
  key: 0,
  class: "muchContent"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "btnParent"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("申请延期撤回")
const _hoisted_14 = {
  key: 3,
  class: "footerCon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalVis,
      footer: null,
      centered: "",
      width: "600px",
      "mask-closable": _ctx.maskClosable,
      bodyStyle: {
        display: 'flex',
        minHeight: '250px',
        justifyContent: 'center',
        alignItems: 'center',
      },
      onCancel: _ctx.cancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.modal.noticeType === 'success')
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.modal.noticeType === 'warning')
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.modal.noticeType === 'error')
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            _hoisted_5
          ]),
          (_ctx.showContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, " Approved No:" + _toDisplayString(_ctx.modal.approvedNo) + "     Rejected No:" + _toDisplayString(_ctx.modal.rejectedNo) + "     Total No:" + _toDisplayString(_ctx.modal.totalNo), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["confirmCon hasBtnConfirm", { longCon: _ctx.modal.content.length > 20 }])
              }, [
                (_ctx.muchContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.muchDet, (key, index) => {
                        return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(key), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.modelContentVisible && !_ctx.muchContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.modal.content), 1))
                  : _createCommentVNode("", true)
              ], 2)),
          (_ctx.modal.withdrawBtnVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.submit,
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.modal.content !== '已过期无法撤回')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      onClick: _ctx.handleDelayWithdraw
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.modal.btnVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_a_button, { onClick: _ctx.cancel }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.cancelLabel), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.submitLabel), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "mask-closable", "onCancel"])
  ]))
}